module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_5.10f66710.png";